import { createAction, handleActions } from 'redux-actions'
import client from 'common/util/http'
import { loadStart, loadFinish, loadError } from 'common/redux/root'

const RESET = 'assignment/RESET'
const LOAD = 'assignment/LOAD'

const load = createAction(LOAD)
const reset = createAction(RESET)

const defaultErrorHandler = dispatch => error => {
  dispatch(loadError(error))
  return Promise.reject(error)
}

export function fetchAssignments(timeframe, excludeOnHold = false, spilloverOnly = false, nav = {}, reset_ = false) {
  return (dispatch, getState) => {
    if (reset_) dispatch(reset())
    let search_time = new Date().valueOf()
    dispatch(loadStart())
    dispatch(load({lastSearchTime: search_time}))

    return client.post('assignments', {
      data: {
        timeframe,
        search_time,
        exclude_on_hold: excludeOnHold,
        spillover_only: spilloverOnly,
        nav: nav
      }})
      .then(response => {
        const { lastSearchTime } = getState().assignment
        if (response.search_time === lastSearchTime) {
          dispatch(load(response))
          dispatch(loadFinish())
        }
        return Promise.resolve(response)
      })
    .catch(dispatch(defaultErrorHandler))
  }
}

export function searchAssignments(timeframe, query, filters, excludeOnHold, spilloverOnly, nav) {
  return (dispatch, getState) => {
    let search_time = new Date().valueOf()
    dispatch(loadStart())
    dispatch(load({lastSearchTime: search_time}))
    return client.post('assignments', {
      data: {
        timeframe,
        query,
        filters,
        search_time,
        exclude_on_hold: excludeOnHold,
        spillover_only: spilloverOnly,
        nav: nav
      }
    })
      .then(response => {
        const { lastSearchTime } = getState().assignment
        if (response.search_time === lastSearchTime) {
          dispatch(load(response))
          dispatch(loadFinish())
        }
        return Promise.resolve(response)
      })
      .catch(dispatch(defaultErrorHandler))
  }
}

export function fetchReleasedAssignments(timeframe, nav={}) {
  return (dispatch, getState) => {
    let search_time = new Date().valueOf()
    dispatch(loadStart())
    dispatch(load({lastSearchTime: search_time}))
    return client.post('released_assignments_paged', {
      data: {
        timeframe,
        search_time,
        nav: nav
      }
    })
      .then(response => {
        const { lastSearchTime } = getState().assignment
        if (response.search_time === lastSearchTime) {
          dispatch(load(response))
          dispatch(loadFinish())
        }
        return Promise.resolve(response)
      })
      .catch(dispatch(defaultErrorHandler))
  }
}

export function searchReleasedAssignments(timeframe, query, filters, nav) {
  return (dispatch, getState) => {
    let search_time = new Date().valueOf()
    dispatch(loadStart())
    dispatch(load({lastSearchTime: search_time}))
    return client.post('released_assignments_paged', {
      data: {
        timeframe,
        query,
        filters,
        search_time,
        nav: nav
      }
    })
      .then(response => {
        const { lastSearchTime } = getState().assignment
        if (response.search_time === lastSearchTime) {
          dispatch(load(response))
          dispatch(loadFinish())
        }
        return Promise.resolve(response)
      })
      .catch(dispatch(defaultErrorHandler))
  }
}

const initialState = {
  assignmentsHidden: {},
  releasedAssignmentsHidden: {},
}

export default handleActions({
    [LOAD]: (state, { payload }) => ({ ...state, ...payload }),
    [RESET]: () => ({ ...initialState }),
}, initialState)
